
//init Block Positions
export default function initBlockPositions() {
    const container = document.querySelector('#main > .container');
    if (!container) return;

    function changeHandler() {
        const offset = container.offsetLeft + 30;
        document.body.style.setProperty('--offset', `${offset}px`);
    }

    changeHandler();
    window.addEventListener("resize", changeHandler);
    window.addEventListener("orientationchange", changeHandler);
}